<app-generic-toolbar
  [toolbarType]="toolbarType"
  [toolbarOptions]="toolbarOptions"
></app-generic-toolbar>
@if(searchEnabled | async) {
  <div class="search-container">
    <div class="search-bar">
      <input type="text" placeholder="Search report" [(ngModel)]="searchTerm" (ngModelChange)="search()"/>
      @if(!searchTerm) {
        <em class="icon-search"></em>
      } @else {
        <div class="search-controls">
          <span>{{currentMatch}}/{{matchCount}}</span>
          <span class="separator">|</span>
          <em class="icon-down_small" (click)="search(false)"></em>
          <em class="icon-up_small" (click)="search(true)"></em>
        </div>
      }
    </div>
  </div>
}
<pdf-viewer
  [src]="url()"
  [render-text]="true"
  [zoom]="zoomLevel"
  [show-all]="true"
  [original-size]="true"
  (after-load-complete)="onPdfLoaded()"
  class= "pdf-viewer"
></pdf-viewer>
